module.exports = __webpack_public_path__ + "static/media/WeatherDashboard.88393345.PNG";